import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from '../core/guards/auth.guard';
import {FormsComponent} from './containers/forms/forms.component';
import {EditFormsComponent} from './components/edit-forms/edit-forms.component';

const routes: Routes = [
  {
    path: 'intelligencedata/country/answerforms', canActivate: [AuthGuard],
    children: [
      {path: '', component: FormsComponent},
      {path: ':id/:userId', component: EditFormsComponent }
    ]
  },
  {
    path: 'intelligencedata/weeesystem/answerforms', canActivate: [AuthGuard],
    children: [
      {path: '', component: FormsComponent},
      {path: ':id/:userId', component: EditFormsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntelligenceDataEntryRoutingModule { }
